var map = {
	"./animal-4085255_1280-removebg-preview.png": 84264,
	"./animal-8165466_1280-removebg-preview 3.png": 53002,
	"./cat-551554_1280__1_-removebg-preview.png": 82660,
	"./dog-4988985_1280-removebg-preview 3.png": 90105,
	"./dog-8198719_1280-removebg-preview.png": 43426,
	"./european-shorthair-8107433_1280-removebg-preview.png": 76365,
	"./european-shorthair-8142967_1280-removebg-preview.png": 30200,
	"./image 820.png": 11600,
	"./image 821.png": 8505,
	"./image 822.png": 60322,
	"./image 823.png": 81451,
	"./image 824.png": 35540,
	"./image 825.png": 56669,
	"./image 826.png": 15430,
	"./image 827.png": 54447,
	"./image 828.png": 86968,
	"./image 829.png": 71585,
	"./image 830.png": 61211,
	"./image 831.png": 46994,
	"./image 832.png": 37705,
	"./image 833.png": 82880,
	"./image 834.png": 34207,
	"./image 835.png": 37878,
	"./image 836.png": 19501,
	"./image 837.png": 79556,
	"./image 838.png": 37219,
	"./image 839.png": 19642,
	"./image 840.png": 30790,
	"./image 841.png": 12335,
	"./image 842.png": 90868,
	"./image 843.png": 11997,
	"./image 844.png": 66626,
	"./image 845.png": 40779,
	"./image 846.png": 26960,
	"./image 847.png": 33209,
	"./image 848.png": 43822,
	"./image 849.png": 43319,
	"./image 850.png": 55905,
	"./image 851.png": 83192,
	"./image 852.png": 57683,
	"./image 853.png": 6922,
	"./image 854.png": 91589,
	"./image 855.png": 57724,
	"./image 856.png": 62807,
	"./image-1.png": 95840,
	"./image-2.png": 93403,
	"./image.png": 85970,
	"./pet-1284307_1280-removebg-preview.png": 65231,
	"./rabbit-2649157.png": 73552,
	"./rabbit-7656358.png": 28244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67800;